module.exports = __webpack_public_path__ + "img/pic-3.d18fdaa2.png";